import {
	TRANSACTIONAL_BENCHMARK,
	TRANSACTIONAL_CROSS_SELLING,
	PERFORMANCE_GROWTH_PROFILING,
	SELLOUT_REPORT_SUBMODULE,
} from "../../constants/paths"

import { ReactComponent as SelloutIcon } from "@livingdesign/pictograms/dist/svg/App_&_Web_Interface/RequestPersonalInfo.svg"
import { ReactComponent as curbsideIcon } from "@livingdesign/pictograms/dist/svg/Pickup_&_Delivery/CurbsidePickup.svg"
import { ReactComponent as plantGrowth } from "@livingdesign/pictograms/dist/svg/Miscellaneous/EnhancingSustainability.svg"
import { ReactComponent as crossSellingIcon } from "assets/icons/cross_selling.svg"

export const submodules = [
	{
		featureFlagId: "transactionalBenchmark",
		titleIntlId: "phronesis.transactional.application.benchmark.title",
		descriptionIntlId:
			"phronesis.transactional.application.benchmark.description",
		iconId: curbsideIcon,
		url: TRANSACTIONAL_BENCHMARK,
	},
	{
		featureFlagId: "performanceGrowthProfiling",
		titleIntlId: "phronesis.transactional.application.growth-profiling.title",
		descriptionIntlId:
			"phronesis.transactional.application.growth-profiling.description",
		iconId: plantGrowth,
		url: PERFORMANCE_GROWTH_PROFILING,
	},
	{
		featureFlagId: "transactionalCrossSelling",
		titleIntlId: "phronesis.transactional.application.cross-selling.title",
		descriptionIntlId:
			"phronesis.transactional.application.cross-selling.description",
		iconId: crossSellingIcon,
		url: TRANSACTIONAL_CROSS_SELLING,
	},
	{
		featureFlagId: "selloutReport",
		titleIntlId: "phronesis.sellout_report.application.sellout_report",
		descriptionIntlId:
			"phronesis.sellout_report.application.reporting_sellout.description",
		iconId: SelloutIcon,
		url: SELLOUT_REPORT_SUBMODULE,
	},
]
